import React from "react";
import { Tag } from "antd";

const SbTag = ({ children, closable = false, onClose, ...rest }) => {
    return (
        <Tag
            closable={closable}
            onClose={onClose}
            {...rest}
        >
            {children}
        </Tag>
    );
};

export default SbTag;